// @flow
import React from 'react';
import {Input} from 'reactstrap';
import Autocomplete from "./AutocompleteField";

/**
 * State suggest
 *
 * Field který automaticky dotahuje data z api a posílá jej do autocomplete
 */
class StateSuggestField extends React.Component {

    state = {
      data: null
    }

    static PropTypes = {
        apiCall: React.PropTypes.func.isRequired
    };

    componentDidMount() {
        const {apiCall} = this.props;
        apiCall().then((data) => {
            this.setState({data})
        });
    }

    render() {
        const {data} = this.state;
        const {apiCall, ...other} = this.props;

        if (!data) {
            return <Input
                type="text"
                disabled={true}
            />
        }

        return <Autocomplete
            items={data}
            {...other}
        />;
    }
}


export default StateSuggestField;
